// AIS Oral Exam Questions - extracted verbatim from the PDF
export const SECTIONS = [
  {
    id: "retour-projet",
    title: "Retour sur le projet",
    short: "Projet",
    description:
      "Questions pour vérifier que vous avez réellement participé au projet et compris vos choix techniques.",
    groups: [
      {
        id: "presentation-projet",
        title: "Présentation du projet",
        questions: [
          { id: "q1", text: "Quel a été votre rôle exact dans le projet présenté ?" },
          { id: "q2", text: "Quel était le besoin exprimé au départ par l'entreprise ou par le contexte de formation ?" },
          { id: "q3", text: "Quelles étaient les principales contraintes techniques, humaines ou organisationnelles ?" },
          { id: "q4", text: "Pourquoi avez-vous choisi cette solution plutôt qu'une autre ?" },
          { id: "q5", text: "Quelles mesures de sécurité avez-vous mises en place dans votre projet ?" },
          { id: "q6", text: "Comment avez-vous vérifié que la solution fonctionnait correctement ?" },
          { id: "q7", text: "Quelle difficulté avez-vous rencontrée et comment l'avez-vous résolue ?" },
          { id: "q8", text: "Si vous deviez refaire ce projet, qu'amélioreriez-vous ?" },
        ],
      },
    ],
  },
  {
    id: "competence-7",
    title: "Compétence 7 — Supervision",
    short: "C7 Supervision",
    description:
      "Mettre en œuvre et optimiser la supervision des infrastructures.",
    groups: [
      {
        id: "c7-indicateurs",
        title: "Choix des indicateurs",
        questions: [
          { id: "q9", text: "Comment choisissez-vous les indicateurs et événements à superviser pour les infrastructures ?" },
        ],
      },
      {
        id: "c7-outils",
        title: "Mise en œuvre des outils",
        questions: [
          { id: "q10", text: "Comment mettez-vous en œuvre ou optimisez-vous les outils de supervision nécessaires ?" },
        ],
      },
    ],
  },
  {
    id: "competence-10",
    title: "Compétence 10 — Incidents de sécurité",
    short: "C10 Incidents",
    description:
      "Participer à la détection et au traitement des incidents de sécurité.",
    groups: [
      {
        id: "c10-detection",
        title: "Détection",
        questions: [
          { id: "q11", text: "Comment configurez-vous et exploitez-vous un dispositif de détection d'événements de sécurité pour détecter et qualifier un incident ?" },
        ],
      },
      {
        id: "c10-reaction",
        title: "Réaction",
        questions: [
          { id: "q12", text: "Comment appliquez-vous les mesures de réaction en réponse à un incident de sécurité pour minimiser l'impact sur les actifs de l'entreprise ?" },
        ],
      },
      {
        id: "c10-veille",
        title: "Veille",
        questions: [
          { id: "q13", text: "Comment assurez-vous votre veille en cybersécurité pour adapter les règles de détection et de traitement des incidents aux nouvelles menaces ?" },
        ],
      },
    ],
  },
  {
    id: "ad-privileges",
    title: "Active Directory & comptes à privilèges",
    short: "AD & Privilèges",
    description: "Modèle Tier, PAM, moindre privilège, élévation de privilèges.",
    groups: [
      {
        id: "ad-questions",
        title: "Questions du jury",
        questions: [
          { id: "q14", text: "Pourquoi Active Directory est-il une cible privilégiée des attaquants ?" },
          { id: "q15", text: "Quelle différence faites-vous entre un compte utilisateur, un compte administrateur et un compte de service ?" },
          { id: "q16", text: "Pourquoi faut-il éviter d'utiliser un compte administrateur pour les tâches courantes ?" },
          { id: "q17", text: "Que signifie le principe du moindre privilège ?" },
          { id: "q18", text: "Comment sécuriser les comptes à privilèges ?" },
          { id: "q19", text: "À quoi sert une architecture en Tier-0, Tier-1 et Tier-2 ?" },
          { id: "q20", text: "Pourquoi un administrateur Tier-0 ne doit-il pas se connecter sur un poste utilisateur Tier-2 ?" },
          { id: "q21", text: "Quels risques entraîne le vol d'un compte administrateur de domaine ?" },
          { id: "q22", text: "Quelles mesures mettriez-vous en place pour limiter l'élévation de privilèges ?" },
          { id: "q23", text: "Quel est l'intérêt d'un bastion ou d'un PAM ?" },
        ],
      },
    ],
  },
  {
    id: "supervision-supp",
    title: "Supervision (questions complémentaires)",
    short: "Supervision +",
    description: "Indicateurs, seuils, tableaux de bord, sauvegardes, certificats.",
    groups: [
      {
        id: "supervision-questions",
        title: "Questions du jury",
        questions: [
          { id: "q24", text: "Quels éléments devez-vous superviser en priorité dans une infrastructure critique ?" },
          { id: "q25", text: "Quelle différence faites-vous entre disponibilité, performance et capacité ?" },
          { id: "q26", text: "Comment éviter les fausses alertes dans un outil de supervision ?" },
          { id: "q27", text: "Pourquoi faut-il définir des seuils d'alerte ?" },
          { id: "q28", text: "Quelle différence faites-vous entre supervision technique et supervision sécurité ?" },
          { id: "q29", text: "Comment exploiter un tableau de bord de supervision ?" },
          { id: "q30", text: "Que faites-vous si un serveur critique devient indisponible ?" },
          { id: "q31", text: "Comment vérifiez-vous qu'une sauvegarde fonctionne réellement ?" },
          { id: "q32", text: "Pourquoi faut-il superviser les certificats, les disques et les services ?" },
          { id: "q33", text: "Comment prioriser plusieurs alertes reçues en même temps ?" },
        ],
      },
    ],
  },
  {
    id: "incidents-supp",
    title: "Incidents de sécurité (complément)",
    short: "Incidents +",
    description: "Qualification, gravité, ransomware, traces, PCA/PRA.",
    groups: [
      {
        id: "incidents-questions",
        title: "Questions du jury",
        questions: [
          { id: "q34", text: "Qu'est-ce qu'un incident de sécurité ?" },
          { id: "q35", text: "Quelle différence faites-vous entre événement, alerte et incident ?" },
          { id: "q36", text: "Comment qualifiez-vous la gravité d'un incident ?" },
          { id: "q37", text: "Quelle est la première action à mener face à une suspicion de compromission ?" },
          { id: "q38", text: "Pourquoi faut-il conserver les journaux d'événements ?" },
          { id: "q39", text: "Que doit contenir un rapport d'incident ?" },
          { id: "q40", text: "Comment réagir face à un ransomware ?" },
          { id: "q41", text: "Pourquoi ne faut-il pas effacer les traces trop rapidement ?" },
          { id: "q42", text: "Comment organiser une reprise après incident ?" },
          { id: "q43", text: "Quelle différence faites-vous entre PCA et PRA ?" },
        ],
      },
    ],
  },
  {
    id: "veille-posture",
    title: "Veille & posture professionnelle",
    short: "Veille & Posture",
    description: "Sources de veille, communication, documentation, gestion de crise.",
    groups: [
      {
        id: "veille-questions",
        title: "Questions du jury",
        questions: [
          { id: "q44", text: "Comment organisez-vous votre veille cybersécurité ?" },
          { id: "q45", text: "Quelles sources de veille utilisez-vous ?" },
          { id: "q46", text: "Comment transformez-vous une information de veille en action concrète ?" },
          { id: "q47", text: "Comment expliquez-vous un risque technique à une direction non technique ?" },
          { id: "q48", text: "Que faites-vous si une procédure de sécurité gêne les utilisateurs ?" },
          { id: "q49", text: "Comment documentez-vous une intervention ?" },
          { id: "q50", text: "Comment travaillez-vous avec une équipe système, réseau ou sécurité ?" },
          { id: "q51", text: "Comment priorisez-vous vos tâches en situation de crise ?" },
          { id: "q52", text: "Comment garantissez-vous la confidentialité des informations auxquelles vous avez accès ?" },
          { id: "q53", text: "Quelles qualités sont importantes pour un administrateur d'infrastructures sécurisées ?" },
        ],
      },
    ],
  },
  {
    id: "relances-jury",
    title: "Relances du jury",
    short: "Relances",
    description: "Questions de relance pour pousser le candidat à donner des exemples concrets.",
    groups: [
      {
        id: "relances",
        title: "Questions de relance",
        questions: [
          { id: "q54", text: "Donnez-moi un exemple dans votre projet." },
          { id: "q55", text: "Comment l'avez-vous vérifié techniquement ?" },
          { id: "q56", text: "Quel journal ou quel outil utiliseriez-vous pour le prouver ?" },
          { id: "q57", text: "Quelle serait la conséquence si cette mesure n'était pas mise en place ?" },
          { id: "q58", text: "Quelle amélioration proposeriez-vous en production ?" },
        ],
      },
    ],
  },
];

export const ALL_QUESTIONS = SECTIONS.flatMap((section) =>
  section.groups.flatMap((group) =>
    group.questions.map((q) => ({
      ...q,
      sectionId: section.id,
      sectionTitle: section.title,
      sectionShort: section.short,
      groupId: group.id,
      groupTitle: group.title,
    }))
  )
);

export const TOTAL_QUESTIONS = ALL_QUESTIONS.length;

// Build the full question list including custom (imported) questions.
export function buildAllQuestions(customQuestions = []) {
  const sectionMap = new Map(SECTIONS.map((s) => [s.id, s]));
  const enriched = customQuestions
    .map((cq) => {
      const section = sectionMap.get(cq.sectionId);
      if (!section) return null;
      const group = section.groups.find((g) => g.id === cq.groupId) || section.groups[0];
      return {
        id: cq.id,
        text: cq.text,
        sectionId: section.id,
        sectionTitle: section.title,
        sectionShort: section.short,
        groupId: group.id,
        groupTitle: group.title,
        custom: true,
        importId: cq.importId,
      };
    })
    .filter(Boolean);
  return [...ALL_QUESTIONS, ...enriched];
}
